import { Numeric6BoxMultipleOutlineIcon } from './Numeric6BoxMultipleOutlineIcon';

/**
 * author: Google
 * id F3AA6A15-D060-40D7-A301-9EB1BAAF2F12
 * name numeric-6-box-multiple-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/numeric-6-box-multiple-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const Numeric6BoxesOutlineIcon = Numeric6BoxMultipleOutlineIcon;
export default Numeric6BoxesOutlineIcon